"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryPhoneNumberInput = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var SummaryPhoneNumberInput = /** @class */ (function (_super) {
    __extends(SummaryPhoneNumberInput, _super);
    function SummaryPhoneNumberInput(props) {
        var _this = _super.call(this, props) || this;
        var phoneNumberValid = (0, commonFunctions_1.validatePhoneNumber)(_this.props.phoneNumber);
        _this.state = {
            phoneNumber: _this.props.phoneNumber,
            phoneNumberValid: phoneNumberValid,
            showInputField: !phoneNumberValid
        };
        _this.handlePhoneNumberChange = _this.handlePhoneNumberChange.bind(_this);
        return _this;
    }
    SummaryPhoneNumberInput.prototype.render = function () {
        return (React.createElement("div", { className: "detail mobile-number ".concat(this.state.showInputField ? "phone-input" : "") },
            React.createElement("div", { className: "detail-key" }, "Mobile phone number:"),
            React.createElement("div", { className: "detail-value ".concat(this.state.phoneNumberValid ? "" : "text-danger") },
                this.state.phoneNumberValid && !this.state.showInputField && this.state.phoneNumber,
                !this.state.phoneNumberValid &&
                    React.createElement("div", { className: "mt-2" }, "The phone number doesn\u2019t look right..."),
                this.state.showInputField &&
                    React.createElement("input", { id: "phoneNumberInput", onChange: this.handlePhoneNumberChange, placeholder: "07XXXXXXX", type: "tel", className: "form-control mt-2" }))));
    };
    SummaryPhoneNumberInput.prototype.handlePhoneNumberChange = function (event) {
        event.preventDefault();
        var phoneNumber = event.target.value;
        this.setState({
            phoneNumber: phoneNumber,
            phoneNumberValid: (0, commonFunctions_1.validatePhoneNumber)(phoneNumber)
        });
        this.props.onStateChange("policyHolder.phoneNumber", phoneNumber);
    };
    ;
    return SummaryPhoneNumberInput;
}(React.Component));
exports.SummaryPhoneNumberInput = SummaryPhoneNumberInput;
//# sourceMappingURL=SummaryPhoneNumberInput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/annual/SummaryPhoneNumberInput.js
// module id = 1237
// module chunks = 0